import { InvestmentEntity } from '../entities/investment-entity';

export default class State {
  loaded = false;

  items: Array<InvestmentEntity> = [];
}
